import { render, staticRenderFns } from "./payment-status.vue?vue&type=template&id=1059ab4a&"
import script from "./payment-status.vue?vue&type=script&lang=js&"
export * from "./payment-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports